// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Arial', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding: 0;
  
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.ant-table-wrapper .ant-table-thead>tr>th {
  color:#0065A4;
}

.ant-select-single .ant-select-selector {
  
  border-radius:0px;
}

.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
  height:35px;
}
.ant-select-multiple .ant-select-selector {
  border-radius:0px;
   height:35px;
   overflow-y: scroll; 
}

.ant-picker .ant-picker-range {
  border-radius:0px;
}

.ant-select-show-search .ant-select:not(.ant-select-customize-input) .ant-select-selector {
  height:35px;
  overflow-y: scroll
}

.ant-menu .ant-menu-item-group-title {
  padding:0px 0px 0px 0px
 }

a:hover {  
     background-color: #e8edf0 !important; 

}
.ant-checkbox-checked .ant-checkbox-inner { 
  border-color: #0a0b0b;
}

.ant-checkbox .ant-checkbox-inner { 
  border-color: #0a0b0b;
}

.anticon {
  vertical-align: 0em;
}

.ant-card-bordered { 
  border: none
}

.ant-upload-wrapper .ant-upload-drag .ant-upload-btn {
  place-content: flex-start !important;
}

.ant-select .ant-select-arrow { 
  top: 64%;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,UAAU;;AAEZ;;AAEA;EACE;aACW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;GAChB,WAAW;GACX,kBAAkB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;CACD;;AAED;KACK,oCAAoC;;AAEzC;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,QAAQ;AACV","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Arial', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  padding: 0;\n  \n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.ant-table-wrapper .ant-table-thead>tr>th {\n  color:#0065A4;\n}\n\n.ant-select-single .ant-select-selector {\n  \n  border-radius:0px;\n}\n\n.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {\n  height:35px;\n}\n.ant-select-multiple .ant-select-selector {\n  border-radius:0px;\n   height:35px;\n   overflow-y: scroll; \n}\n\n.ant-picker .ant-picker-range {\n  border-radius:0px;\n}\n\n.ant-select-show-search .ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  height:35px;\n  overflow-y: scroll\n}\n\n.ant-menu .ant-menu-item-group-title {\n  padding:0px 0px 0px 0px\n }\n\na:hover {  \n     background-color: #e8edf0 !important; \n\n}\n.ant-checkbox-checked .ant-checkbox-inner { \n  border-color: #0a0b0b;\n}\n\n.ant-checkbox .ant-checkbox-inner { \n  border-color: #0a0b0b;\n}\n\n.anticon {\n  vertical-align: 0em;\n}\n\n.ant-card-bordered { \n  border: none\n}\n\n.ant-upload-wrapper .ant-upload-drag .ant-upload-btn {\n  place-content: flex-start !important;\n}\n\n.ant-select .ant-select-arrow { \n  top: 64%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
